import React, { useEffect, useState } from "react";
import { Button } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Button/Button";
import { Paragraph } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";
import { NewsletterInputs } from "../NewsletterInputs";
import { NewsletterInfo } from "../NewsletterInfo";
import useSubscribeCustomer from "@src/hooks/useSubscribeCustomer";
import useCreateCustomer from "@src/hooks/useCreateCustomer";
import {BusinessFields, InputField, CheckboxField} from "@stories/ecommerce/Account/AccountFoodClubFields";
import NewsletterRegisterForm from "@src/stories/ecommerce/Account/NewsletterRegisterForm";

export const Default = ({ settings, onClick = null }) => {
  const { requestedSuccess, serverMessage, isSubmitting, subscribe } = useSubscribeCustomer();
  const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);

    const [isBusiness, setIsBusiness] = useState(false);

  const [email, setEmail] = useState("");
  const { section, blocks } = settings;
  const show_button = true;
  const button_text = section.button_text;
  const image = section.image;
  const [dependenciesState, setDependenciesState] = useState({});
    const { createCustomer, loading, error, customerId, success } = useCreateCustomer();
    const isCustomerLoggedIn = settings.globals.is_customer_logged_in;

    const customSignupFields = settings.signupfields;

      // Function to update the global dependencies state
      const updateDependencyState = (name, value) => {
        setDependenciesState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        if (name === "email") {
          setEmail(value);
        }
      };

    const handleBusinessToggle = () => {
        setIsBusiness(!isBusiness);
    };
    const handleInputChange = (e) => {
        const { name, value, type: inputType, checked } = e.target;
        const newValue = inputType === "checkbox" ? checked : value;
        updateDependencyState(name, newValue);
    };

  const infoBlock = blocks.find((block) => block.type === "cta_info");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const customer_posted = params.get("customer_posted");
    if (customer_posted === "true") {
      setIsSuccess(true);
    }
  }, []);

  const handleClick = (event) => {
    event.preventDefault();
    // Since this is newsletter, set optIn fields automatically
    setDependenciesState((prevState) => ({
        ...prevState,
        ['optInSMS']: true,
        ['optInEmail']: true,
    }));
    const response = createCustomer(dependenciesState);
  };

  return (
      <div className="container calltoaction h-auto relative newsletter">
        {image &&
          <div
            className={"w-full h-full absolute top-0 left-0 content-over-media"}
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPositionY: "center",
            }}
          ></div>
        }

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12 w-full">
          <NewsletterInfo settings={settings} />

          {isCustomerLoggedIn
            ? <div className="px-4 z-[10]">
                <p className="h5">You have already subscribed</p>
                <p className="b3">
                    <a href={'/account'}>Click here to visit your account.</a>
                </p>
              </div>

            : <NewsletterRegisterForm settings={settings} />
          }
        </div>
      </div>
  );
};

export default Default;
